export const NEXT_BUTTON_CLASS_NAME = 'vjs-next-button';
